<ul class="pager">
    <li ng-class="{disabled: noPrevious(), previous: align}"><a href ng-click="selectPage(page - 1, $event)">Previous</a></li>
    <li ng-class="{disabled: noNext(), next: align}"><a href ng-click="selectPage(page + 1, $event)">Next</a></li>
</ul>
